var anchorMenu = document.querySelector('.c-side-bar');
if (anchorMenu){
	var anchors = anchorMenu.querySelectorAll('a[href^="#"]');
	anchors.forEach(anchor => {
		anchor.addEventListener('click', function (e) {
			e.preventDefault();
			const yOffset = -100;
			const element = document.getElementById(this.getAttribute('href').substring(1));
			let y;
			if(element === null){
			y = 0;
			}else{
			y = element.getBoundingClientRect().top + window.pageYOffset + yOffset;
			}
			window.scrollTo({top: y, behavior: 'smooth'});
		});
	});
	var selector = anchorMenu.querySelector('select');
	selector.addEventListener('change', e=>{
		e.preventDefault();
		const yOffset = -100;
		const element = document.getElementById(selector.value.substring(1));
		let y;
		if(element === null){
			y = 0;
		}else{
			y = element.getBoundingClientRect().top + window.pageYOffset + yOffset;
		}
		window.scrollTo({top: y, behavior: 'smooth'});
	})
}